function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeetingPending = function SvgMeetingPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.729,
    height: 21.215,
    viewBox: "0 0 3.368 5.613"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2Zm10 14.5V20H8v-3.5l4-4zm-4-5-4-4V4h8v3.5z",
    style: {
      fill: "#999",
      stroke: "none"
    },
    transform: "matrix(.28066 0 0 .28066 -1.684 -.561)"
  }));
};
export default SvgMeetingPending;